export const TIMEZONES = [
  { label: '(UTC-11:00) American Samoa (SST)', value: 'Pacific/Pago_Pago' },
  {
    label: '(UTC-10:00) Hawaii Standard Time (HST)',
    value: 'Pacific/Honolulu'
  },
  { label: '(UTC-10:00) Honolulu', value: 'Pacific/Honolulu' },
  { label: '(UTC-10:00) Tahiti (TAHT)', value: 'Pacific/Tahiti' },
  {
    label: '(UTC-09:00) Alaska Standard Time (AKST)',
    value: 'America/Anchorage'
  },
  { label: '(UTC-09:00) Anchorage, Fairbanks', value: 'America/Anchorage' },
  {
    label: '(UTC-08:00) Pacific Standard Time (PST)',
    value: 'America/Los_Angeles'
  },
  { label: '(UTC-08:00) Los Angeles, Vancouver', value: 'America/Los_Angeles' },
  {
    label: '(UTC-07:00) Mountain Standard Time (MST)',
    value: 'America/Denver'
  },
  { label: '(UTC-07:00) Denver, Calgary', value: 'America/Denver' },
  {
    label: '(UTC-06:00) Central Standard Time (CST)',
    value: 'America/Chicago'
  },
  { label: '(UTC-06:00) Chicago, Mexico City', value: 'America/Chicago' },
  {
    label: '(UTC-05:00) Eastern Standard Time (EST)',
    value: 'America/New_York'
  },
  { label: '(UTC-05:00) New York, Toronto', value: 'America/New_York' },
  {
    label: '(UTC-04:00) Atlantic Standard Time (AST)',
    value: 'America/Halifax'
  },
  { label: '(UTC-04:00) Halifax, Caracas', value: 'America/Halifax' },
  { label: '(UTC-03:00) Brasília Time (BRT)', value: 'America/Sao_Paulo' },
  { label: '(UTC-03:00) São Paulo, Buenos Aires', value: 'America/Sao_Paulo' },
  {
    label: '(UTC-01:00) Azores Standard Time (AZOT)',
    value: 'Atlantic/Azores'
  },
  {
    label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    value: 'Europe/London'
  },
  { label: '(UTC+00:00) Greenwich Mean Time (GMT)', value: 'Europe/London' },
  {
    label: '(UTC+00:00) Western European Summer Time (WEST)',
    value: 'Europe/Lisbon'
  },
  { label: '(UTC+01:00) Central European Time (CET)', value: 'Europe/Berlin' },
  {
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'Europe/Berlin'
  },
  { label: '(UTC+01:00) West Africa Time (WAT)', value: 'Africa/Lagos' },
  { label: '(UTC+01:00) Lagos', value: 'Africa/Lagos' },
  {
    label: '(UTC+02:00) Eastern European Time (EET)',
    value: 'Europe/Helsinki'
  },
  { label: '(UTC+02:00) Helsinki', value: 'Europe/Helsinki' },
  { label: '(UTC+02:00) Central Africa Time (CAT)', value: 'Africa/Cairo' },
  { label: '(UTC+02:00) Cairo', value: 'Africa/Cairo' },
  {
    label: '(UTC+02:00) Athens, Bucharest, Istanbul',
    value: 'Europe/Bucharest'
  },
  { label: '(UTC+03:00) Moscow Standard Time (MSK)', value: 'Europe/Moscow' },
  {
    label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd',
    value: 'Europe/Moscow'
  },
  { label: '(UTC+03:00) East Africa Time (EAT)', value: 'Africa/Nairobi' },
  { label: '(UTC+03:00) Nairobi', value: 'Africa/Nairobi' },
  { label: '(UTC+03:30) Iran Standard Time (IRST)', value: 'Asia/Tehran' },
  { label: '(UTC+03:30) Tehran', value: 'Asia/Tehran' },
  { label: '(UTC+04:00) Gulf Standard Time (GST)', value: 'Asia/Dubai' },
  { label: '(UTC+04:00) Abu Dhabi, Muscat', value: 'Asia/Dubai' },
  { label: '(UTC+04:00) Georgia Standard Time (GET)', value: 'Asia/Baku' },
  { label: '(UTC+04:00) Baku', value: 'Asia/Baku' },
  { label: '(UTC+04:30) Kabul', value: 'Asia/Kabul' },
  { label: '(UTC+04:30) Afghanistan Time (AFT)', value: 'Asia/Kabul' },
  { label: '(UTC+05:00) Pakistan Standard Time (PKT)', value: 'Asia/Karachi' },
  { label: '(UTC+05:00) Uzbekistan Time (UZT)', value: 'Asia/Tashkent' },
  { label: '(UTC+05:00) Tashkent', value: 'Asia/Tashkent' },
  { label: '(UTC+05:30) Indian Standard Time (IST)', value: 'Asia/Kolkata' },
  {
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'Asia/Kolkata'
  },
  { label: '(UTC+05:45) Nepal Time (NPT)', value: 'Asia/Kathmandu' },
  { label: '(UTC+05:45) Kathmandu', value: 'Asia/Kathmandu' },
  { label: '(UTC+06:00) Bangladesh Time (BDT)', value: 'Asia/Dhaka' },
  { label: '(UTC+06:00) Astana, Dhaka', value: 'Asia/Dhaka' },
  { label: '(UTC+06:00) Alma-Ata Time (ALMT)', value: 'Asia/Almaty' },
  { label: '(UTC+06:00) Almaty', value: 'Asia/Almaty' },
  { label: '(UTC+06:30) Yangon (Rangoon)', value: 'Asia/Yangon' },
  { label: '(UTC+06:30) Myanmar Time (MMT)', value: 'Asia/Yangon' },
  { label: '(UTC+07:00) Indochina Time (ICT)', value: 'Asia/Bangkok' },
  { label: '(UTC+07:00) Bangkok, Hanoi, Jakarta', value: 'Asia/Bangkok' },
  { label: '(UTC+07:00) Western Indonesia Time (WIB)', value: 'Asia/Jakarta' },
  { label: '(UTC+08:00) China Standard Time (CST)', value: 'Asia/Shanghai' },
  {
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    value: 'Asia/Shanghai'
  },
  { label: '(UTC+09:00) Japan Standard Time (JST)', value: 'Asia/Tokyo' },
  { label: '(UTC+09:00) Osaka, Sapporo, Tokyo', value: 'Asia/Tokyo' },
  { label: '(UTC+09:00) Korea Standard Time (KST)', value: 'Asia/Seoul' },
  { label: '(UTC+09:00) Seoul', value: 'Asia/Seoul' },
  {
    label: '(UTC+09:30) Australian Central Standard Time (ACST)',
    value: 'Australia/Adelaide'
  },
  { label: '(UTC+09:30) Adelaide', value: 'Australia/Adelaide' },
  {
    label: '(UTC+10:00) Australian Eastern Standard Time (AEST)',
    value: 'Australia/Sydney'
  },
  { label: '(UTC+10:00) Brisbane', value: 'Australia/Brisbane' },
  {
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    value: 'Australia/Sydney'
  },
  {
    label: '(UTC+11:00) Solomon Islands Time (SBT)',
    value: 'Pacific/Guadalcanal'
  },
  { label: '(UTC+11:00) Honiara', value: 'Pacific/Guadalcanal' },
  { label: '(UTC+11:00) New Caledonia Time (NCT)', value: 'Pacific/Noumea' },
  { label: '(UTC+11:00) Nouméa', value: 'Pacific/Noumea' },
  {
    label: '(UTC+11:00) Magadan, Solomon Is., New Caledonia',
    value: 'Pacific/Noumea'
  },
  {
    label: '(UTC+12:00) New Zealand Standard Time (NZST)',
    value: 'Pacific/Auckland'
  },
  { label: '(UTC+12:00) Auckland, Wellington', value: 'Pacific/Auckland' },
  { label: '(UTC+12:00) Fiji Time (FJT)', value: 'Pacific/Fiji' },
  { label: '(UTC+12:00) Suva', value: 'Pacific/Fiji' },
  { label: "(UTC+13:00) Nuku'alofa", value: 'Pacific/Tongatapu' },
  { label: '(UTC+14:00) Kiritimati Island', value: 'Pacific/Kiritimati' }
]
